var FOCUSABLE_SELECTOR = 'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), input[type="email"]:not([disabled]), input[type="password"]:not([disabled]), input[type="button"]:not([disabled]), input[type="submit"]:not([disabled]), select:not([disabled])';

function getVisibleFocusable(container) {
	return Array.prototype.slice.call(container.querySelectorAll(FOCUSABLE_SELECTOR)).filter(function (node) { return node.offsetParent !== null;});
}

function trapFocus(element, onEscape) {
	var container = (element && element[0]) || element;
	if (!container) {
		return function () {};
	}

	var previousFocus = document.activeElement;

	function handleKeydown(e) {
		if(e.key === 'Escape') {
			if (typeof onEscape === 'function') {
				onEscape();
			} else {
				$('body > .overlay').trigger('click');
			}
			return;
		} else if (e.key !== 'Tab') {
			return;
		}

		var focusableEls = getVisibleFocusable(container);
		if (!focusableEls.length) {
			return;
		}

		var firstEl = focusableEls[0];
		var lastEl = focusableEls[focusableEls.length - 1];

		if (e.shiftKey && document.activeElement === firstEl) {
			lastEl.focus();
			e.preventDefault();
		} else if (!e.shiftKey && document.activeElement === lastEl) {
			firstEl.focus();
			e.preventDefault();
		}
	}

	container.addEventListener('keydown', handleKeydown);

	var focusableEls = getVisibleFocusable(container);
	if (focusableEls.length) {
		focusableEls[0].focus();
	}

	return function releaseFocus() {
		container.removeEventListener('keydown', handleKeydown);

		if (previousFocus && typeof previousFocus.focus === 'function') {
			previousFocus.focus();
		}
	};
}

module.exports = { trapFocus };
